import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "1. Acceptance of Terms",
    blocks: [
      {
        type: "p",
        text: 'By accessing or using the Sassy Full Stack Fitness Transformation Calculator (the "Tool"), you agree to be bound by these Terms & Conditions and our Privacy Policy. If you do not agree, please do not use the Tool.',
      },
    ],
  },
  {
    heading: "2. The Service",
    blocks: [
      {
        type: "p",
        text: 'The Tool provides estimated nutrition macros and an AI-generated "future you" transformation image based on the information you submit. It is an informational and marketing tool offered by Sassy Full Stack Fitness ("we," "us," "our").',
      },
    ],
  },
  {
    heading: "3. Not Medical or Professional Advice",
    blocks: [
      {
        type: "p",
        text: "The Tool does not provide medical, nutritional, or professional health advice, diagnosis, or treatment. Calorie and macro estimates are general calculations and may not be appropriate for you. Always consult a qualified physician or healthcare provider before starting any diet, supplement, or exercise program. You use the Tool at your own risk.",
      },
    ],
  },
  {
    heading: "4. AI Transformation Images",
    blocks: [
      {
        type: "p",
        text: "Transformation images are computer-generated illustrations created by a third-party AI model. They are artistic estimates only, are not a prediction, promise, or guarantee of any actual physical result, and should not be relied upon as such. Individual results vary.",
      },
    ],
  },
  {
    heading: "5. Eligibility",
    blocks: [
      {
        type: "p",
        text: "You must be at least 18 years old to use the Tool and submit your information.",
      },
    ],
  },
  {
    heading: "6. Text Messaging Terms",
    blocks: [
      {
        type: "p",
        text: "If you opt in to text messages, you agree to receive recurring automated marketing and informational texts from Sassy Full Stack Fitness at the number you provide. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to cancel or HELP for help. Mobile opt-in data and consent are never shared with third parties. See our Privacy Policy for details.",
      },
    ],
  },
  {
    heading: "7. Your Content & License",
    blocks: [
      {
        type: "p",
        text: "Any photo you upload remains yours. By uploading, you grant us a limited license to process and store that photo solely to generate and display your transformation preview. You represent that you have the right to upload any photo you submit.",
      },
    ],
  },
  {
    heading: "8. Acceptable Use",
    blocks: [
      {
        type: "p",
        text: "You agree not to misuse the Tool, upload unlawful or infringing content, upload photos of anyone without their permission, or attempt to disrupt or reverse-engineer the service.",
      },
    ],
  },
  {
    heading: "9. Intellectual Property",
    blocks: [
      {
        type: "p",
        text: "All content, branding, and software associated with the Tool are owned by Sassy Full Stack Fitness or its licensors and are protected by applicable laws.",
      },
    ],
  },
  {
    heading: "10. Disclaimers & Limitation of Liability",
    blocks: [
      {
        type: "p",
        text: 'The Tool is provided "as is" and "as available" without warranties of any kind. To the fullest extent permitted by law, Sassy Full Stack Fitness is not liable for any indirect, incidental, or consequential damages arising from your use of the Tool.',
      },
    ],
  },
  {
    heading: "11. Changes to These Terms",
    blocks: [
      {
        type: "p",
        text: "We may update these Terms from time to time. Continued use of the Tool after changes means you accept the updated Terms.",
      },
    ],
  },
  {
    heading: "12. Contact",
    blocks: [
      {
        type: "p",
        text: "Questions? Contact us at support@sassyfitness.com or visit sassyfitness.com.",
      },
    ],
  },
];

const Terms = () => (
  <LegalPage
    title="Terms &"
    accent="Conditions"
    updated="Last updated: August 2026"
    sections={sections}
    testId="terms-page"
    docTitle="Terms & Conditions | Sassy Full Stack Fitness"
  />
);

export default Terms;
